import { GQLOrderFragment, GQLOrderItemFragment, GQLOrderItemPrintDecorationType, GQLOrderItemPrintFragment } from '@theprintbar/graphql';

export function OrderNeedsEmbApproval(order: GQLOrderFragment) {
	return !!order.items?.some(OrderItemNeedsEmbApproval);
}

export function OrderItemNeedsEmbApproval(orderItem: Pick<GQLOrderItemFragment, 'prints'>) {
	return orderItem.prints?.some(OrderItemDecorationNeedsEmbApproval);
}

export function OrderItemDecorationNeedsEmbApproval(decoration: GQLOrderItemPrintFragment) {
	return (
		decoration.decoration === GQLOrderItemPrintDecorationType.Emb &&
		(!decoration.decorationThreads.structure?.length ||
			(!decoration.decorationFile && !decoration.attachments?.find(a => a.file?.filename.toLowerCase().includes('.dst'))))
	);
}
